export default __webpack_public_path__ + "static/media/no-rates.912a1df3.svg";